import { render, staticRenderFns } from "./LineArrowIcon.vue?vue&type=template&id=49ca57ba&"
import script from "./LineArrowIcon.vue?vue&type=script&lang=js&"
export * from "./LineArrowIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports